import { Event } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Event>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const eventReducer = createReducer<State, Actions>(initialState, {
  [actions.getEvent.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getEvent.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getEvent.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.toggleFavoriteEvent.success.type]: (draft, action) => {
    const event: any = draft.byId[action.payload.id];
    if (event) event.user_favorite = !event.user_favorite;
  },
});

export default eventReducer;
